<div class="lang-toggle" role="group" aria-label="Language">
  <button
    type="button"
    class="lang-toggle__btn"
    [class.lang-toggle__btn--active]="current() === 'pl'"
    [attr.aria-pressed]="current() === 'pl'"
    (click)="onSelect('pl')">
    PL
  </button>
  <button
    type="button"
    class="lang-toggle__btn"
    [class.lang-toggle__btn--active]="current() === 'en'"
    [attr.aria-pressed]="current() === 'en'"
    (click)="onSelect('en')">
    EN
  </button>
</div>
